import { Component, OnInit } from '@angular/core';
import { GlobalInfoService } from '@app/core';



@Component({
  selector: 'iw-iframe-management',
  templateUrl: './iframe-management.component.html',
  styleUrls: ['./iframe-management.component.scss'],
  providers: []
})
export class IframeManagementComponent implements OnInit {
  constructor(
    private gis: GlobalInfoService
  ) { }

  ngOnInit() {
    // se setea el titulo de la vista actual
    this.gis.set({ title: 'Administración de Iframes dinámicos' });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/iframe-management/iframe-management.component.ts